import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import throttle from 'lodash/throttle';
import ColorPicker from 'react-best-gradient-color-picker';
import { useCallback, useState, useMemo } from 'react';
import { autoUpdate, flip, FloatingPortal, offset, shift, useDismiss, useFloating, useInteractions } from '@floating-ui/react';
import { decodeColors, encodeColors } from '@/utils/colors';
import { useTheme } from '@/components/widget/Layout/ThemeProvider';
import universalDesignSystem from '@/config/colorPallets/universalDesignSystem';
import { FALLBACK_COLOR, getChangedColor, convertPalletToRGB, withColorPresets } from './utils';
import Label from '@/components/FormElements/Label';
import Button from '@/components/Button';
import Checkboard from './Checkboard';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.1548 0.488155C17.8057 -0.162718 18.861 -0.162718 19.5118 0.488155C20.1627 1.13903 20.1627 2.1943 19.5118 2.84518L12.357 10L19.5118 17.1548C20.1627 17.8057 20.1627 18.861 19.5118 19.5118C18.861 20.1627 17.8057 20.1627 17.1548 19.5118L10 12.357L2.84518 19.5118C2.1943 20.1627 1.13903 20.1627 0.488156 19.5118C-0.162719 18.861 -0.162719 17.8057 0.488156 17.1548L7.64298 10L0.488156 2.84518C-0.162718 2.1943 -0.162718 1.13903 0.488156 0.488155C1.13903 -0.162718 2.19431 -0.162718 2.84518 0.488155L10 7.64298L17.1548 0.488155Z",
      fill: "#BABDCC"
    })
  }));
};

CloseIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const EditorFieldsColorPicker = _ref => {
  let {
    id,
    label,
    caption,
    size,
    className,
    defaultValue,
    colorPallet = [],
    defaults,
    disabled = false,
    deleteDisabled = false,
    enableGradientPicker = false,
    onChange = () => undefined,
    onDelete
  } = _ref;
  const {
    colorPresets,
    baseColorPresets
  } = useTheme();
  const {
    0: isColorPickerVisible,
    1: setIsColorPickerVisible
  } = useState(false);
  const {
    0: selectedColor,
    1: setSelectedColor
  } = useState(typeof defaultValue === 'string' ? decodeColors(defaultValue)[0] : ''); // Parse & update selected color
  // and publish the encoded value
  // eslint-disable-next-line react-hooks/exhaustive-deps

  const handleChange = useCallback(throttle(srcValue => {
    // Use custom callback for delete action
    if (srcValue === null && typeof onDelete === 'function') {
      onDelete();
      return;
    }

    const changed = getChangedColor(srcValue || '', selectedColor || '', defaults);
    setSelectedColor(changed);
    onChange(changed ? encodeColors(changed) : null);
  }, 400, {
    leading: true
  }), [onChange, defaults]); // Convert HEX to RGB

  const rgbColorPallet = useMemo(() => withColorPresets(convertPalletToRGB(colorPallet, colorPresets || []), baseColorPresets || []), [colorPallet, colorPresets, baseColorPresets]); // Handle picker positioning

  const {
    refs,
    floatingStyles,
    context
  } = useFloating({
    placement: 'right-start',
    open: isColorPickerVisible,
    whileElementsMounted: autoUpdate,
    onOpenChange: setIsColorPickerVisible,
    middleware: [offset({
      mainAxis: -20,
      crossAxis: 32
    }), flip(), shift()]
  }); // close menu on outside click or escape key

  const dismiss = useDismiss(context);
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([dismiss]);
  return /*#__PURE__*/_jsxs("fieldset", {
    className: clsx(parentStyles.formField, parentStyles['formField--pill'], styles.container, className || '', {
      [styles[`container--${size}`]]: size
    }),
    children: [label ? /*#__PURE__*/_jsx("legend", {
      className: clsx(parentStyles.legend, {
        [parentStyles[`legend--${size}`]]: size
      }),
      children: label
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsxs(Label, _objectSpread(_objectSpread({}, id && {
      forInput: id
    }), {}, {
      className: clsx(styles.colorValue, {
        [styles[`colorValue--${size}`]]: size
      }),
      children: [/*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
        ref: refs.setReference
      }, getReferenceProps()), {}, {
        className: styles.colorValue__color,
        style: {
          background: selectedColor || 'transparent'
        }
      }, !disabled && {
        onClick: () => setIsColorPickerVisible(true)
      })), /*#__PURE__*/_jsx("div", {
        className: styles['colorValue__color--background'],
        children: /*#__PURE__*/_jsx(Checkboard, {
          size: 14,
          white: "#fff",
          grey: universalDesignSystem.gray20
        })
      })]
    })), /*#__PURE__*/_jsxs("aside", {
      className: styles.aside,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "button",
        size: "small",
        variant: "text",
        className: styles.editButton,
        disabled: disabled,
        onClick: () => setIsColorPickerVisible(true),
        children: "Edit Color"
      }), caption ? /*#__PURE__*/_jsx("p", {
        className: clsx(styles.subHeading, {
          [styles[`subHeading--${size}`]]: size
        }),
        children: caption
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), /*#__PURE__*/_jsx(FloatingPortal, {
      children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
        ref: refs.setFloating,
        className: styles.colorPicker,
        style: floatingStyles
      }, getFloatingProps()), {}, {
        children: isColorPickerVisible ? /*#__PURE__*/_jsx("div", {
          className: styles.colorPicker__card,
          children: /*#__PURE__*/_jsx(ColorPicker, {
            value: selectedColor || FALLBACK_COLOR,
            width: 220,
            height: 150,
            onChange: value => handleChange(value),
            presets: rgbColorPallet,
            disableDarkMode: true,
            hideAdvancedSliders: true,
            hideColorGuide: true,
            hideInputType: true,
            hideEyeDrop: true,
            hideGradientControls: !enableGradientPicker,
            hideControls: !enableGradientPicker,
            hidePresets: rgbColorPallet.length === 0
          })
        }) : /*#__PURE__*/_jsx(_Fragment, {})
      }))
    }), selectedColor && !deleteDisabled ? /*#__PURE__*/_jsx("button", {
      type: "button",
      className: styles.deleteButton,
      onClick: () => {
        handleChange(null);
        setIsColorPickerVisible(false);
      },
      children: /*#__PURE__*/_jsx(CloseIcon, {})
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default EditorFieldsColorPicker;